import createActions from 'utils/redux/createActions'

export default createActions([
	'CHANGED_CONTENT'
  , 'ADDED_ATTACHMENT'
  , 'DELETE_ATTACHMENT_NEW_COMMENT'
  , 'RESET_FORM'
])



// WEBPACK FOOTER //
// ./src/actions/newCommentActions.js